<template>
  <div>
    <div fluid class="pad pb-0 px-8">
      <!-- Filter Dialog -->
    <v-dialog v-model="filterDialog" class="cdz" max-width="570px" style="z-index:1000 !important">
      <v-card width="570px" height="100vh" class="filterDialogClass">
        <v-row class="mt-4 mx-1">
          <v-col>
            <div class="pl-0 mb-2 text-body1 font-weight-bold grey--text">
              Filter
            </div>
          </v-col>
          <v-col class="d-flex justify-end">
            <div
              @click="clearFilter"
              class="clear-filter-btn"
            >
              CLEAR FILTER
            </div>
          </v-col>
        </v-row>
        <v-tabs vertical>   
          <div class="ml-3 mt-4 mr-4 filterLine">
            <v-tab key="stage" class="black--text justify-start" active-class="activeTab">
              Stage
              <span v-if="selectedStageFilter.length > 0" class="ml-1">
              ({{ selectedStageFilter.length }})</span>
            </v-tab>
            <v-tab key="CoreSkillsSubject" class="black--text justify-start" active-class="activeTab">
              League
              <span v-if="selectedLeagueFilter.length > 0" class="ml-1">
                ({{ selectedLeagueFilter.length }})</span>
            </v-tab>
          </div>

          <v-tab-item key="stage">
            <v-card>
              <v-card-text>
                <v-chip-group v-model="selectedStageFilter" active-class="secondary" column :multiple="true">
                  <v-chip v-for="(stage,index) in stageOptions" 
                  :key="index"
                  :value="stage"
                  elevated>
                    {{stage}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item key="CoreSkillsSubject">
            <v-card>
              <v-card-text>
                <v-chip-group v-model="selectedLeagueFilter" active-class="secondary" column :multiple="true">
                  <v-chip v-for="(league,index) in leagueOptions" 
                  :key="index"
                  :value="league"
                  elevated>
                    {{league}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
        <div class="filterDialogButton">
          <v-card-actions class="px-6 pb-0">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              outlined
              class="accent--text pa-4"
              @click="closeFilter"
              >Cancel</v-btn
            >
            <v-btn
              class="accent pa-4"
              :disabled="selectedStageFilter.length==0 && selectedLeagueFilter.length==0"
              @click="filterTeachers(selectedStageFilter,selectedLeagueFilter),getFilterCount()">Apply</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>                
    </v-dialog>
  </div>
    <v-col>
      <v-card
        height="64px"
        width="100%"
        class="mx-4 pl-3 pt-5 pr-4 background elevation-0 d-flex flex-row justify-space-between align-center fixBar"
      >
        <v-card-title class="pl-0 ml-0">
          <v-span
            @click="$router.push('/')"
            class="breadcrumb-text-unselected underline-on-hover cursor"
            >Dashboard</v-span
          >

          <v-span
            ><v-icon class="breadcrumb-arrow-unselected"
              >mdi-chevron-right</v-icon
            ></v-span
          >
          <v-menu offset-y class="menuZindex">
            <template v-slot:activator="{ on }">
              <v-span v-on="on" class="breadcrumb-text">
                Campaign Result
                <v-icon class="breadcrumb-arrow cursor"
                  >mdi-chevron-down</v-icon
                >
              </v-span>
            </template>

            <v-list>
              <v-list-item @click="$router.push('/teachersappraisal')"
                >No. of teachers to be Appraised</v-list-item
              >
              <v-list-item @click="$router.push('/teacherspip')"
                >No. of teachers on PIP</v-list-item
              >
              <v-list-item @click="$router.push('/teacherstbd')"
                >No. of teachers on TBD</v-list-item
              >
            </v-list>
          </v-menu>
        </v-card-title>
        <UserNavMenu/>
      </v-card>

      <div class="pt-12">
        <div class="background fixTop30 ml-2 pt-4">
          <v-container class="funnel-contianer pr-7 pl-0 ml-3" fluid>
            <div class="w-100 d-flex flex-row">
              <div class="rounded-lg px-0 py-0 pl-1 flex-item-1">
                <v-card
                  class="rounded-lg pr-0 pl-0 cardBorder"
                  width="100%"
                  height="30vh"
                >
                  <v-card-title class="pb-2 pl-1 pr-0 pt-1">
                    <p class="py-0 my-0 pl-2 funnelText">
                      TEACHERS
                    </p>
                  </v-card-title>
    
                  <v-card-text class="pt-0  mt-n2 pr-0 pl-0">
                    <span class="pl-3 black--text"
                      >Registered/Invited</span
                    >
                    <FunnelChartCommon :invites="funnelTeachersData" scaleMax="invited" propertyBegin="invited" propertyEnd="screeningStarted" funnelColor="#E0ED4B"/>
                    <div class="d-flex justify-end py-1 pr-2">
                      <img src="../assets/streamline_graph-arrow-decrease.svg" alt="Icon"/>
                      <div 
                        class="red--text pl-2"
                        style="display: inline-block; margin-bottom: 0">
                        {{
                          calculatePercentage(
                            funnelTeachersData.invited -
                              funnelTeachersData.mainsStarted,
                            funnelTeachersData.invited
                          )
                        }}%
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
    
              <!-- <div class="rounded-lg px-0 py-0 pl-1 flex-item-1">
                <v-card
                  class="rounded-lg pr-0 pl-0 cardBorder"
                  width="100%"
                  height="30vh"
                >
                  <v-card-title class="pb-2 pl-1 pr-0 pt-1">
                    <p class="py-0 my-0 pl-2 funnelText">
                      SCREENING
                    </p>
                  </v-card-title>
    
                  <v-card-text class="pt-0  mt-n2 pr-0 pl-0">
                    <span class="pl-3 black--text"
                      >Attempted</span
                    >
                    <FunnelChartCommon :invites="funnelTeachersData" scaleMax="invited" propertyBegin="screeningStarted" propertyEnd="screeningPassed" funnelColor="#C3ED4B"/>
                    <div class="d-flex justify-end py-1 pr-2">
                      <img src="../assets/streamline_graph-arrow-decrease.svg" alt="Icon"/>
                      <div 
                        class="red--text pl-2"
                        style="display: inline-block; margin-bottom: 0">
                        {{
                          calculatePercentage(
                            funnelTeachersData.screeningStarted -
                              funnelTeachersData.screeningPassed,
                            funnelTeachersData.screeningStarted
                          )
                        }}%
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div> -->
              <!-- <div class="rounded-lg px-0 py-0 pl-1 flex-item-1">
                <v-card
                  class="rounded-lg pr-0 pl-0 cardBorder"
                  width="100%"
                  height="30vh"
                >
                  <v-card-title class="pb-2 pl-1 pr-0 pt-1">
                    <p class="py-0 my-0 pl-2 funnelText">
                      SCREENING RESULT
                    </p>
                  </v-card-title>
    
                  <v-card-text class="pt-0  mt-n2 pr-0 pl-0">
                    <span class="pl-3 green--text"
                      >Passed</span
                    >
                    <FunnelChartCommon :invites="funnelTeachersData" scaleMax="invited" propertyBegin="screeningPassed" propertyEnd="mainsStarted" funnelColor="#B0D644"/>
                    <div class="d-flex justify-end py-1 pr-2">
                      <img src="../assets/streamline_graph-arrow-decrease.svg" alt="Icon"/>
                      <div 
                        class="red--text pl-2"
                        style="display: inline-block; margin-bottom: 0">
                        {{
                          calculatePercentage(
                            funnelTeachersData.screeningPassed -
                              funnelTeachersData.mainsStarted,
                            funnelTeachersData.screeningPassed
                          )
                        }}%
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div> -->
              <div class="rounded-lg px-0 py-0 pl-1 flex-item-1">
                <v-card
                  class="rounded-lg pr-0 pl-0 cardBorder"
                  width="100%"
                  height="30vh"
                >
                  <v-card-title class="pb-2 pl-1 pr-0 pt-1">
                    <p class="py-0 my-0 pl-2 funnelText">
                      MAINS
                    </p>
                  </v-card-title>
    
                  <v-card-text class="pt-0  mt-n2 pr-0 pl-0">
                    <span class="pl-3 black--text"
                      >Attempted</span
                    >
                    <FunnelChartCommon :invites="funnelTeachersData" scaleMax="invited" propertyBegin="mainsStarted" propertyEnd="mainsPassed" funnelColor="#6AD644"/>
                    <div class="d-flex justify-end py-1 pr-2">
                      <img src="../assets/streamline_graph-arrow-decrease.svg" alt="Icon"/>
                      <div 
                        class="red--text pl-2"
                        style="display: inline-block; margin-bottom: 0">
                        {{
                          calculatePercentage(
                            funnelTeachersData.mainsStarted -
                              funnelTeachersData.mainsPassed,
                            funnelTeachersData.mainsStarted
                          )
                        }}%
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
              <div class="rounded-lg px-0 py-0 pl-1 flex-item-1">
                <v-card
                  class="rounded-lg pr-0 pl-0 cardBorder"
                  width="100%"
                  height="30vh"
                >
                  <v-card-title class="pb-2 pl-1 pr-0 pt-1">
                    <p class="py-0 my-0 pl-2 funnelText">
                      MAINS RESULT
                    </p>
                  </v-card-title>
    
                  <v-card-text class="pt-0  mt-n2 pr-0 pl-0">
                    <span class="pl-3 green--text"
                      >Passed</span
                    >
                    <FunnelChartCommon :invites="funnelTeachersData" scaleMax="invited" propertyBegin="mainsPassed" propertyEnd="demoSubmitted"/>
                    <div class="d-flex justify-end py-1 pr-2">
                      <img src="../assets/streamline_graph-arrow-decrease.svg" alt="Icon"/>
                      <div 
                        class="red--text pl-2"
                        style="display: inline-block; margin-bottom: 0">
                        {{
                          calculatePercentage(
                            funnelTeachersData.mainsPassed -
                              funnelTeachersData.demoSubmitted,
                            funnelTeachersData.mainsPassed
                          )
                        }}%
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
              <!-- <div class="rounded-lg px-0 py-0 pl-1 flex-item-1">
                <v-card
                  class="rounded-lg pr-0 pl-0 cardBorder"
                  width="100%"
                  height="30vh"
                >
                  <v-card-title class="pb-2 pl-1 pr-0 pt-1">
                    <p class="py-0 my-0 pl-2 funnelText">
                      DEMO
                    </p>
                  </v-card-title>
    
                  <v-card-text class="pt-0  mt-n2 pr-0 pl-0">
                    <span class="pl-3 black--text"
                      >Attempted</span
                    >
                    <FunnelChartCommon :invites="funnelTeachersData" scaleMax="invited" propertyBegin="demoSubmitted" propertyEnd="interviewSubmitted"/>
                    <div class="d-flex justify-end py-1 pr-2">
                      <img src="../assets/streamline_graph-arrow-decrease.svg" alt="Icon"/>
                      <div 
                        class="red--text pl-2"
                        style="display: inline-block; margin-bottom: 0">
                        {{
                          calculatePercentage(
                            funnelTeachersData.demoSubmitted -
                              funnelTeachersData.interviewSubmitted,
                            funnelTeachersData.demoSubmitted
                          )
                        }}%
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div> -->
              <div class="rounded-lg px-0 py-0 pl-1 w-19">
                <v-card
                  class="cardBorder rounded-lg pr-0 pl-0"
                  width="100%"
                  height="30vh"
                >
                  <v-card-title class="pr-0 pl-0 py-0">
                    <p class="font-weight-bold pl-2 funnelText">
                      CAMPAIGN SUMMARY
                    </p>
                  </v-card-title>

                  <v-card
                    outlined
                    class="font-weight-medium pl-2 d-flex align-center rounded mx-3 my-2"
                    width="80%"
                    @click="$router.replace('/teachersappraisal')"
                    height="5vh"
                  >
                    <!-- For Appraisal : {{ apraisals }} -->
                    For Appraisal : {{ appraisedTeachersCount }}

                    <v-spacer></v-spacer>
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-card>
                  <v-card
                    outlined
                    class="font-weight-medium pl-2 d-flex align-center rounded mx-3 my-2"
                    width="80%"
                    @click="$router.replace('/teacherspip')"
                    height="5vh"
                  >
                    <!-- For PIP : {{ pip }} -->
                    For PIP : {{ pipTeachersCount }}

                    <v-spacer></v-spacer>
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-card>
                  <v-card
                    outlined
                    class="font-weight-medium pl-2 d-flex align-center rounded mx-3 my-2 blue-outline"
                    width="80%"
                    height="5vh"
                  >
                    <!-- For TBD : {{ tbd }} -->
                    For TBD : {{ tbdTeachersCount }}
                    <v-spacer></v-spacer>
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-card>

                  <v-card
                    outlined
                    class="font-weight-medium pl-2 d-flex align-center rounded mx-3 my-2"
                    width="80%"
                    height="5vh"
                    @click="$router.replace('/teachersothers')"

                  >
                    Others : {{ otherTeachersCount }}
                    <v-spacer></v-spacer>
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-card>
                </v-card>
              </div>
            </div>
            <!-- <v-col cols="2.5">
                <FunnelChart/>
               </v-col>
               <v-col cols="2.5">
                <FunnelChart/>
               </v-col>
               <v-col cols="2.5">
                <FunnelChart/>
               </v-col> -->
          </v-container>

          <v-row class="d-flex justify-center pt-0 my-0 ml-3 pr-1" fluid>
            <v-col cols="4" md="4" sm="4" class="pl-1">
              <div class="text-h6 font-weight-bold highEmphasis">
                <!-- Teachers on TBD ({{ tbd }}) -->
                Teachers on TBD ({{ tbdTeachersCount }})
              </div>
            </v-col>

            <v-col cols="8" md="8" sm="8" class="d-flex flex-row justify-end">
              <v-card class="elevation-0 ma-0 pa-0 transparent">
                <v-text-field
                  solo
                  hide-details
                  label="Search here..."
                  prepend-inner-icon="mdi-magnify"
                  v-model="search"
                  class="search-bar border-button rounded-pill mx-3"
                  dense
                  clearable
                ></v-text-field>
              </v-card>

              <v-btn depressed rounded outlined @click="showfilterdialogue" :disabled="tbdTeachersCount==0" class="border-button mx-3"
                ><v-icon>mdi-tune</v-icon>
                <span v-if="filterCount > 0">FILTER ({{ filterCount }})</span>
                <span v-else>FILTER</span>
              </v-btn>
              <!-- <v-btn depressed rounded outlined class="border-button mx-3"
            ><img src="../../public/svgs/SORT.svg" alt="" />SORT</v-btn
          > -->

              <!-- <v-btn
              class="primary mx-2" rounded><v-icon>mdi-export</v-icon>Export</v-btn> -->
              <v-btn depressed outlined rounded @click="downloadTeachersOnTBD" :disabled="topTeacherInSchool.length==0" class="border-button mx-3"
                ><v-icon>mdi-import mdi-rotate-90</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </div>

        <v-card
          elevation="0"
          height="55px"
          class="d-flex align-center rounded-table mx-5"
          color="#B2AC88"
        >
          <v-row class="pl-4">
            <v-col cols="1" class="reportTableText"> S.No </v-col>
            <v-col cols="2" class="reportTableText mr-8"> Full Name </v-col>
            <v-col cols="2" class="reportTableText"> Campaign </v-col>
            <v-col cols="2" class="reportTableText"> SchoolName </v-col>
            <v-col cols="1" class="reportTableText"> Invited </v-col>
            <!-- <v-col cols="1" class="reportTableText"> Screening </v-col> -->
            <v-col cols="1" class="reportTableText"> Mains </v-col>
            <!-- <v-col cols="1" class="reportTableText"> Demo </v-col> -->
            <v-col cols="1" class="text-center reportTableText"> League </v-col>
            <v-col cols="1" class="text-end reportTableText"> Action </v-col>

          </v-row>
        </v-card>
        <v-card
          class="rounded-table mx-5 mt-2"
          id="myScroll"
          height="350px"
          elevation="0"
        >
          <v-list elevation="0" class="px-0 py-0">
            <v-list-item
              class="px-0 pl-4 py-0"
              v-for="(item, index) in displayedTeachers"
              :key="item.id"
            >
              <v-row class="px-0 py-0 mt-2">
                <v-col cols="1" class="d-flex flex-row align-center ml-2 py-0">
                  {{ index + 1 }}
                </v-col>
                <v-col
                  class="d-flex flex-row align-center pl-0 mr-8 py-0"
                  cols="2"
                >
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <td class="t-data" v-bind="attrs" v-on="on">
                        {{ `${item.firstName} ${item.lastName}` }}
                      </td>
                    </template>
                    <span style="font-size: 15px">
                      {{
                        "Grade : " +
                        item.responsibleTeachingAt[0].grade +
                        ", " +
                        "Level : " +
                        item.responsibleTeachingAt[0].level +
                        ", " +
                        "Subject : " +
                        item.responsibleTeachingAt[0].subject
                      }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="2" class="d-flex flex-row align-center px-0 py-0">
                  <div class="w-100">{{ item.campaignName }}</div>
                </v-col>
                <v-col cols="2" class="d-flex flex-row align-center px-0 py-0">
                  <div>{{ item.schoolName }}</div>
                </v-col>
                <v-col class="d-flex flex-row align-center py-0 pr-15" cols="2">
                  <v-row class="d-flex flex-row align-center pl-2">
                    <v-icon
                      medium
                      :color="item.stepper.invitation.iconColor"
                      >{{ item.stepper.invitation.name}}
                    </v-icon>
                    <!-- <v-divider
                      :thickness="10"
                      class="border-opacity-25 px-0 py-0"
                       :color="item.stepper.screening.iconColor"
                    ></v-divider>
                    <v-icon
                      medium
                       :color="item.stepper.screening.iconColor"
                    >
                    {{ item.stepper.screening.name}}
                    </v-icon> -->
                    <v-divider
                      :thickness="2"
                      class="border-opacity-87 px-0 py-0"
                      :color="item.stepper.mains.iconColor"
                    ></v-divider>
                    <v-icon
                      medium
                      :color="item.stepper.mains.iconColor"
                    >
                    {{ item.stepper.mains.name}}</v-icon
                    >

                    <!-- <v-divider
                      :thickness="10"
                      class="border-opacity-25 px-0 py-0"
                      :color="item.stepper.demo.iconColor"
                    ></v-divider>
                    <v-icon
                      medium
                      class="pr-8"
                      :color="item.stepper.demo.iconColor"
                      >{{ item.stepper.demo.name}}</v-icon
                    > -->
                  </v-row>
                </v-col>
                <v-col cols="1">
                  <div
                    v-if="
                      item.coreSkillsSubject != undefined &&
                      item.coreSkillsSubject.length > 0
                    "
                    class="text-subtitle-1 d-flex justify-center"
                  >
                    <div
                      v-if="
                        item.coreSkillsSubject.length > 0 &&
                        item.coreSkillsSubject.length <= 3
                      "
                      class="d-flex flex-row w-100 flex-wrap d-flex justify-center"
                    >
                      <div
                        v-for="(coreSkill, index) in item.coreSkillsSubject"
                        :key="index"
                        class="w-fit"
                      >
                        <v-tooltip v-if="coreSkill.leagueValueIcon != 'NA'" top>
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              v-bind="attrs"
                              v-on="on"
                              class="d-flex flex-column align-center mr-6"
                            >
                              <v-icon
                                v-if="coreSkill.league == 'Gold'"
                                height="23px"
                                width="25"
                                class="goldIcons--text"
                              >
                                mdi-shield-crown-outline
                              </v-icon>
                              <v-icon
                                v-if="coreSkill.league == 'Silver'"
                                height="23px"
                                width="25"
                                class="silverIcon--text"
                              >
                                mdi-shield-crown-outline
                              </v-icon>
                              <v-icon
                                v-if="
                                  coreSkill.league == 'Bronze' ||
                                  coreSkill.league == 'Bonze'
                                "
                                height="23px"
                                width="25"
                                class="bronzeIcon--text"
                              >
                                mdi-shield-crown-outline
                              </v-icon>
                            </div>
                          </template>
                          <span style="font-size: 15px"
                            >{{ coreSkill.skillName }} -
                            {{ coreSkill.percentile.toFixed(2) }}%
                          </span>
                        </v-tooltip>
                        <div v-else class="d-flex justify-center mr-8 mt-1">
                          -
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        item.coreSkillsSubject.length > 0 &&
                        item.coreSkillsSubject.length >= 3
                      "
                      class="d-flex flex-row w-100 flex-wrap"
                    >
              
                    <div 
                    v-for="(coreSkill, index) in item.coreSkillsSubject"
                    :key="index"
                    >
                      <v-tooltip v-if="coreSkill.leagueValueIcon != 'NA'" top>
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="on"
                            class="d-flex flex-column align-center ml-6"
                          >
                   
                            <v-icon
                              v-if="item.coreSkillsSubject[0].league == 'Gold'"
                              height="23px"
                              width="25"
                              class="goldIcons--text"
                            >
                              mdi-shield-crown-outline
                            </v-icon>
                            <v-icon
                              v-if="
                                coreSkill.item.coreSkillsSubject[0] == 'Silver'
                              "
                              height="23px"
                              width="25"
                              class="silverIcon--text"
                            >
                              mdi-shield-crown-outline
                            </v-icon>
                            <v-icon
                              v-if="
                                item.coreSkillsSubject[0].league == 'Bronze' ||
                                item.coreSkillsSubject[0].league == 'Bonze'
                              "
                              height="23px"
                              width="25"
                              class="bronzeIcon--text"
                            >
                              mdi-shield-crown-outline
                            </v-icon>
                            <div style="font-size: 12px">
                              #{{ item.coreSkillsSubject[0].rank }}
                            </div>
                          </div>
                        </template>
                        <span style="font-size: 15px"
                          >{{ item.coreSkillsSubject[0].skillName }} -
                          {{
                            item.coreSkillsSubject[0].percentile.toFixed(2)
                          }}%</span
                        >
                      </v-tooltip>
                    </div>
                    <div 
                    v-for="(coreSkill, index) in item.coreSkillsSubject"
                    :key="index"
                    >
                      <v-tooltip v-if="coreSkill.leagueValueIcon != 'NA'" top>
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="on"
                            class="d-flex flex-column align-center ml-6"
                          >
                            <v-icon
                              v-if="item.coreSkillsSubject[1].league == 'Gold'"
                              height="23px"
                              width="25"
                              class="goldIcons--text"
                            >
                              mdi-shield-crown-outline
                            </v-icon>
                            <v-icon
                              v-if="
                                item.coreSkillsSubject[1].league == 'Silver'
                              "
                              height="23px"
                              width="25"
                              class="silverIcon--text"
                            >
                              mdi-shield-crown-outline
                            </v-icon>
                            <v-icon
                              v-if="
                                item.coreSkillsSubject[1].league == 'Bronze' ||
                                item.coreSkillsSubject[1].league == 'Bonze'
                              "
                              height="23px"
                              width="25"
                              class="bronzeIcon--text"
                            >
                              mdi-shield-crown-outline
                            </v-icon>
                            <div style="font-size: 12px">
                              #{{ item.coreSkillsSubject[1].rank }}
                            </div>
                          </div>
                        </template>
                        <span style="font-size: 15px"
                          >{{ item.coreSkillsSubject[1].skillName }} -
                          {{ item.coreSkillsSubject[1].percentile.toFixed(2) }}%
                        </span>
                      </v-tooltip>
                    </div>
                      
                    <div
                    v-for="(coreSkill, index) in item.coreSkillsSubject"
                    :key="index"
                    >
                      <v-tooltip v-if="coreSkill.leagueValueIcon != 'NA'" top>
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="on"
                            class="d-flex flex-column align-center ml-6"
                          >
                            <v-icon
                              v-if="item.coreSkillsSubject[2].league == 'Gold'"
                              height="23px"
                              width="25"
                              class="goldIcons--text"
                            >
                              mdi-shield-crown-outline
                            </v-icon>
                            <v-icon
                              v-if="
                                item.coreSkillsSubject[2].league == 'Silver'
                              "
                              height="23px"
                              width="25"
                              class="silverIcon--text"
                            >
                              mdi-shield-crown-outline
                            </v-icon>
                            <v-icon
                              v-if="
                                item.coreSkillsSubject[2].league == 'Bronze' ||
                                item.coreSkillsSubject[2].league == 'Bonze'
                              "
                              height="23px"
                              width="25"
                              class="bronzeIcon--text"
                            >
                              mdi-shield-crown-outline
                            </v-icon>
                            <div style="font-size: 12px">
                              #{{ item.coreSkillsSubject[2].rank }}
                            </div>
                          </div>
                        </template>
                        <span style="font-size: 15px"
                          >{{ item.coreSkillsSubject[2].skillName }} -
                          {{
                            item.coreSkillsSubject[2].percentile.toFixed(2)
                          }}%</span
                        >
                      </v-tooltip>
                    </div>
                      

                      <v-btn
                        v-if="item.coreSkillsSubject.length >= 3"
                        :loading="btnLoading"
                        @click="
                          openLeagueDialog(
                            item.coreSkillsSubject,
                            item.personalInfo.firstName,
                            item.personalInfo.lastName
                          )
                        "
                        height="10px"
                        width="10px"
                        text
                        color="#1B72E8"
                        class="text-body-2 ml-9 mt-4"
                        >View More</v-btn
                      >
                    </div>
                  </div>
                  <div
                    class="d-flex justify-center mr-8 mt-1"
                    v-if="
                      item.coreSkillsSubject != undefined &&
                      item.coreSkillsSubject.length == 0
                    "
                  >
                    -
                  </div>
                </v-col>
                <v-col cols="1" class="d-flex justify-end" align-self="end">
                  <img
                    @click="getResult(item)"
                    class="cursor mr-3 mb-2"
                    width="24px"
                    src="../assets/Live.svg"
                  />
                  <img
                    v-if="item.userType.toLowerCase() !== 'teacher'"
                    @click="getFinalResult(item)"
                    class="cursor mb-2"
                    width="24px"
                    src="../assets/Final.svg"
                  />

                  <img
                    v-else
                    class="cursor mb-2"
                    width="24px"
                    src="../assets/user_report_disabled.svg"
                  />
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-card>
      </div>
    </v-col>
  </div>
</template>
  
<script >
import AuthService from "@/services/AuthService";
import Papa from "papaparse";
import LeagueController from "@/controllers/LeagueController";
import {
  collection,
  getDocs,
  onSnapshot,
  doc,
} from "firebase/firestore";
import { db } from "../firebase";
import FunnelChartCommon from "./FunnelChartCommon.vue";
import { liveListenerUnsubscriber } from "@/mixins/liveListenerUnsubcriber";
import UserNavMenu from "@/components/UserNavMenu.vue";

export default {
  name: "CampaignResult",
  components: {
    FunnelChartCommon,UserNavMenu
  },
  mixins: [ liveListenerUnsubscriber ],
  data() {
    return {
      data: [
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
        },
        {
          name: "Eclair",
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
        },
        {
          name: "Cupcake",
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
        },

        {
          name: "Honeycomb",
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
        },
      ],
      clusters: [],
      schoolTeacher: [],
      topTeacherInSchool: [],
      campaignNameAdmin: [],
      invited: 0,
      screeningStarted: 0,
      screeningPassed: 0,
      screeningFailed: 0,
      mainsStarted: 0,
      mainsPassed: 0,
      mainsFailed: 0,
      result: 0,
      apraisals: 0,
      pip: 0,
      tbd: 0,
      chartData: {},
      emptyChartData: {
        invited: 0,
        screeningStarted: 0,
        screeningPassed: 0,
        screeningFailed: 0,
        mainsStarted: 0,
        mainsPassed: 0,
        mainsFailed: 0,
      },

      funnelTeachersData: {
        invited: 0,
        screeningStarted: 0,
        screeningPassed: 0,
        screeningFailed: 0,
        mainsStarted: 0,
        mainsPassed: 0,
        mainsFailed: 0,
        demoSubmitted: 0,
        interviewSubmitted: 0,
      },

      hover: "",

      pipTeachersCount: 0,
      appraisedTeachersCount: 0,
      otherTeachersCount: 0,
      tbdTeachersCount: 0,

      filterDialog: false,
      filterCount: 0,
      appliedFilter: false,
      selectedStageFilter : [],
      selectedLeagueFilter : [],
      filteredTeachers: [],
      stageOptions:["Invited","Screening","Mains","Demo"],
      leagueOptions:[],

      search: "",
      searchedResults:[],
      appliedSearch:false,
    };
  },
  computed: {
    displayedTeachers() {
      if(this.appliedFilter==false){
        if(this.appliedSearch==true){
          return this.searchedResults
        }
        else{
          return this.topTeacherInSchool;
        }
        }
      else if(this.appliedFilter==true){
        if(this.appliedSearch==true){
          return this.searchedResults
        }
        else{
          return this.filteredTeachers;
        }
      }
    },
  },

  watch:{
    search(newValue){
      if (newValue=='' || newValue == null) {
        this.appliedSearch=false;
        
      }
      else{
        this.searchData(newValue);
      }
    },
  },

  methods: {
    logout() {
      AuthService.logout();
      this.$router.push("/login");
    },
    filterTeachers(
      selectedStage =[],
      selectedLeague =[]
    ) {
      let stageApplied = selectedStage?.length > 0
      let leagueApplied =  selectedLeague?.length > 0
      this.filteredTeachers = this.topTeacherInCluster
     
      if(stageApplied){  
       this.filterBasedOnStage(selectedStage);
      } 

      if(leagueApplied){
        this.filterBasedOnLeague(selectedLeague,);
      }
    
      this.appliedFilter=true;
      this.filterDialog=false;
    },
    async getLeague()
    { 
      const response = await LeagueController.getLeagues();
      if (response.status==200){
        for (const league of response.data.leagues){
          if (league.name=="Bonze"|| league.name=="Bronze"){
          this.leagueOptions.push("Bronze");
          }
          else{
            this.leagueOptions.push(league.name);
          }
        }
      }
    },

    searchData(search){
      if (this.appliedFilter==true){
        this.searchedResults=this.filteredTeachers.filter((teacher)=>
          new RegExp(search,"i").test(teacher.firstName) || 
          new RegExp(search,"i").test(teacher.lastName) || 
          new RegExp(search,"i").test(`${teacher.firstName} ${teacher.lastName}`)
      );
      }
      else{
        this.searchedResults=this.topTeacherInSchool.filter((teacher)=>
          new RegExp(search,"i").test(teacher.firstName) || 
          new RegExp(search,"i").test(teacher.lastName) || 
          new RegExp(search,"i").test(`${teacher.firstName} ${teacher.lastName}`))
      }
        this.appliedSearch=true;
    },

    showfilterdialogue() {
      this.filterDialog = true;
    },

    closeFilter(){
    this.filterDialog = false;
  },

  filterTeachers(
      selectedStage,
      selectedLeague
    ) {
      this.appliedFilter=true;
      this.filteredTeachers=[];
      for (const teacher of this.topTeacherInSchool) {
        let stageExists = false;
        let leagueExists = false;
        if(selectedStage.length>0){
          const stageOpts = this.stageOptions.map(item=>item.toLowerCase());
          for (const stage of selectedStage){  
            let teacherIndex=stageOpts.findIndex(x=>x==teacher.stage.toLowerCase());
            let selectedIndex=stageOpts.findIndex(x=>x==stage.toLowerCase());
            if (selectedIndex<=teacherIndex){
              stageExists = true;
          }
        }
        }
        else{
          stageExists=true;
        }
        if(selectedLeague.length>0){
           for (const item of teacher.coreSkillsSubject) {
          for (const league of selectedLeague){
            if (item.league==league){
              leagueExists = true;
            }

          }
        }
        }
        else{
          leagueExists=true;
        }
      if (stageExists==true && leagueExists==true){
        this.filteredTeachers.push(teacher)
      }
      this.filterDialog=false;
      }
    },


    clearFilter() {
      this.appliedFilter = false;
      this.selectedStageFilter = "",
      this.selectedLeagueFilter= "",
      this.filterCount = 0,
      this.filteredTeachers=[];
      this.filterDialog = false;
    },

    getFilterCount() {
      this.filterCount = 0;
      if (this.selectedStageFilter.length > 0) {
        this.filterCount++;
      }
      if (this.selectedLeagueFilter.length > 0) {
        this.filterCount++;
      }
    },

    async newTeacherFunnelChartDataListener() {
      const dashboardTeachersRef = doc(
        db,
        "dashboards",
        this.$store.state.role.id + "-vgos-teachers-dashboard",
        "results",
        "campaignresults"
      );

      let unsubscribe = onSnapshot(dashboardTeachersRef, (doc) => {
        const resultData = doc.data();
        if (resultData) {
          this.funnelTeachersData = {
            invited: resultData.invited ? resultData.invited : 0,
            screeningStarted: resultData.screeningStarted? resultData.screeningStarted: 0,
            screeningPassed: resultData.screeningPassed? resultData.screeningPassed: 0,
            screeningFailed: resultData.screeningFailed? resultData.screeningFailed: 0,
            mainsStarted: resultData.mainsStarted ? resultData.mainsStarted : 0,
            mainsPassed: resultData.mainsPassed ? resultData.mainsPassed : 0,
            mainsFailed: resultData.mainsFailed ? resultData.mainsFailed : 0,
            demoSubmitted: resultData.demoSubmitted ? resultData.demoSubmitted : 0,
            interviewSubmitted: resultData.interviewSubmitted ? resultData.interviewSubmitted : 0, 
          };
        }
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },
    async getResult(data) {
      const response = await CampaignController.getResult(data.userId, data.campaignId);
      if (response.status == 200) {
        if (response.data.length == 0) {
          alert("User test not started");
        } else {
          this.$router.push(`/testreport/${data.campaignId}/${data.userId}`);
        }
      } else {
        alert(response.data.error);
      }
    },
    getFinalResult(data) {
      const {href}  = this.$router.resolve({
        path: "/userreport",
        name: "UserReport",
        query: {
          campaignId: data.campaignId,
          userId: data.userId,
        },
      });
      window.open(href, '_blank')
    },
    async setupSnapshotListenerFunnel() {
      const id = collection(
        db,
        "dashboards",
        "management-dashboard-001",
        "campaigns"
      );
      if (id === undefined) {
        this.chartData = this.emptyChartData;
      }
      const data = await getDocs(id);
      if (data === undefined) {
        this.chartData = this.emptyChartData;
      }
      const document = data.docs[0];
      if (document === undefined) {
        this.chartData = this.emptyChartData;
      } else {
        const docRef = doc(id, data.docs[0].id);

        let unsubscribe = onSnapshot(docRef, (snapshot) => {
          let funnelData = snapshot.data();
          if (
            funnelData.invited === undefined ||
            funnelData.screeningStarted === undefined ||
            funnelData.screeningPassed === undefined ||
            funnelData.screeningFailed === undefined ||
            funnelData.mainsStarted === undefined ||
            funnelData.mainsPassed === undefined ||
            funnelData.mainsFailed === undefined
          ) {
            this.chartData = this.emptyChartData;
          } else {
            this.chartData = funnelData;
            this.invited = funnelData.invited;
            this.screeningStarted = funnelData.screeningStarted;
            this.screeningPassed = funnelData.screeningPassed;
            this.mainsStarted = funnelData.mainsStarted;
            this.mainsPassed = funnelData.mainsPassed;
            this.screeningFailed = funnelData.screeningFailed;
            this.mainsFailed = funnelData.mainsFailed;
            this.apraisals = funnelData.mainsPassed;
            this.pip = funnelData.mainsFailed;
            this.tbd = funnelData.screeningFailed;
          }
        });
        this.liveListenersToUnsubscribeMixin.push(unsubscribe);
      }
    },

    downloadTeachersOnTBD() {
        const fileName = "TeachersOnTBD.csv";
        const dataForDownload = [];
        for (const teacher of this.topTeacherInSchool) {
          const fullName = `${teacher.firstName} ${teacher.lastName}`;
          const campaign = teacher.campaignName;
          const schoolName = teacher.schoolName;
          const campstat = teacher.demoStatus?teacher.demoStatus:teacher.campaignStatus[teacher.campaignStatus.length-1].status

          dataForDownload.push({
              FullName : fullName,
              Campaign : campaign,
              SchoolName : schoolName,
              CurrentCampaignStatus : campstat
            });
          }
          this.downloadCSV(dataForDownload,fileName);
    },

    async downloadCSV(csvData, fileName) {
      const csv = Papa.unparse(csvData);

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },

    calculatePercentage(value, total) {
      if (total === 0) {
        return 0;
      }
      const percentage = (value / total) * 100;
      if (isNaN(percentage)) {
        return 0;
      }
      const roundedPercentage = Math.round(percentage);
      return roundedPercentage;
    },

    async teacherSnapshotListener() {
      const campaignRef = collection(db, "campaigns"); 
      this.appraisedTeachersCount = 0;
      this.pipTeachersCount = 0;
      this.tbdTeachersCount = 0;
      this.otherTeachersCount = 0;

      let unsubscribe = onSnapshot(campaignRef, (snapshot) => {
        this.schoolTeacher.splice(0);

        snapshot.docs.forEach(async (doc) => {
          const campaignName = doc.data().name ? doc.data().name : "";
          if (doc.data().audienceType.toLowerCase() === "teacher") {
            try {
              const jobSeekerRef = collection(campaignRef, doc.id, "audience");
              const jobSeekDocs = await getDocs(jobSeekerRef);
              jobSeekDocs.forEach((d) => {
                const teachersData = d.data();
                if (teachersData?.campaignStatus?.length === 5) {
                  if (
                    teachersData.campaignStatus[2].status ===
                      "SCREENING PASSED" &&
                    teachersData.campaignStatus[4].status === "MAINS FAILED"
                  ) {
                    this.pipTeachersCount++;
                  }

                  if (
                    teachersData.campaignStatus[2].status ===
                      "SCREENING FAILED" &&
                    teachersData.campaignStatus[4].status === "MAINS FAILED"
                  ) {
                    this.tbdTeachersCount++;
                  }

                  if (
                    teachersData.campaignStatus[2].status ===
                      "SCREENING FAILED" &&
                    teachersData.campaignStatus[4].status === "MAINS PASSED"
                  ) {
                    this.otherTeachersCount++;
                  }

                  if (
                    teachersData.campaignStatus[2].status ===
                      "SCREENING PASSED" &&
                    teachersData.campaignStatus[4].status === "MAINS PASSED"
                  ) {
                    let flag = true;
                    if (teachersData?.coreSkillsSubject?.length > 0) {
                      for (const dt of teachersData.coreSkillsSubject) {
                        if (dt.league !== "Not Eligible") {
                          flag = false;
                          this.appraisedTeachersCount++;
                          break;
                        }
                      }
                    }
                    if (flag) {
                      this.otherTeachersCount++;
                    }
                  }
                }

                if (
                  teachersData?.campaignStatus?.length === 5 &&
                  teachersData.campaignStatus[2].status ===
                    "SCREENING FAILED" &&
                  teachersData.campaignStatus[4].status === "MAINS FAILED"
                ) {
                  const temp = {
                    firstName: teachersData?.personalInfo?.firstName
                      ? teachersData.personalInfo.firstName
                      : "",
                    lastName: teachersData?.personalInfo?.lastName
                      ? teachersData.personalInfo.lastName
                      : "",
                    campaignName: campaignName,
                    schoolName: teachersData?.schoolName
                      ? teachersData.schoolName
                      : "",
                    screeningTotal: teachersData.screeningTotal
                      ? teachersData.screeningTotal
                      : 0,
                    mainsTotal: teachersData.mainsTotal
                      ? teachersData.mainsTotal
                      : 0,
                    status: teachersData.campaignStatus
                      ? teachersData.campaignStatus[
                          teachersData.campaignStatus.length - 1
                        ].status
                      : "INVITED",
                    responsibleTeachingAt: teachersData.responsibleTeachingAt
                      ? teachersData.responsibleTeachingAt
                      : [[]],
                    stage: "INVITED",
                    campaignStatus: teachersData.campaignStatus,
                    coreSkillsSubject: teachersData.coreSkillsSubject,
                    campaignId :doc.id,
                    userId: teachersData.userId
                  };
                  if (temp.status === "SCREENING FAILED")
                    temp.stage = "Screening";
                  if (temp.status === "MAINS FAILED") temp.stage = "Mains";
                  this.schoolTeacher.push(temp);
                }
              });

              this.topTeacherInSchool = this.calculateUsersForLeague(
                this.schoolTeacher
              );
              this.topTeacherInSchool = this.addDemoInterviewScore(this.topTeacherInSchool)
              this.topTeacherInSchool = this.createStepperData(this.topTeacherInSchool)
            } catch (error) {
              console.error("Error fetching audience collection:", error);
            }
          }
        });
      });
      this.liveListenersToUnsubscribeMixin.push(unsubscribe);
    },
    getPassFailGenericVal(status){
      if(status !== null && status !== undefined && status !== ''){
        return status.split(' ')[1]?.toLowerCase().trim()
      } else{   return ''}
  
    },
  getStepperIconAndColor(prevStatus = '', curStatus = ''){
      let key = prevStatus+curStatus.trim()
      let map = new Map([
        ['started', {name:'mdi-dots-horizontal-circle-outline', iconColor:'blue' }],
        ['startedfailed', {name:'mdi-close-circle', iconColor: 'red'} ],
        ['startedpassed', {name: 'mdi-check-circle', iconColor: 'green'}],
        ['failed',{name:'mdi-circle-double', iconColor: 'grey'}],
        ['failedpassed', {name: 'mdi-check-circle', iconColor: 'green'}],
        ['failedstarted', {name:'mdi-dots-horizontal-circle-outline', iconColor:'blue' }],
        ['passed', {name:'mdi-circle-double', iconColor: 'grey'}],
        ['passedfailed', {name:'mdi-close-circle', iconColor: 'red'} ],
        ['passedstarted', {name:'mdi-dots-horizontal-circle-outline', iconColor:'blue' }],
        ['', {name:'mdi-circle-double', iconColor: 'grey'}],

      ])
      return map.get(key)
    },
    createStepperData(data){
     return data?.map((item)=>{
        let obj = {invitation: { name:'mdi-check-circle', iconColor: 'green'}, 
                 screening:{  },
                 mains:{ },
                 demo:{ },
                 interview:{}}
        let status = item?.campaignStatus;
        obj['screening'] = this.getStepperIconAndColor(this.getPassFailGenericVal(status[1]?.status), this.getPassFailGenericVal(status[2]?.status))
        obj['mains'] = this.getStepperIconAndColor(this.getPassFailGenericVal(status[3]?.status), this.getPassFailGenericVal(status[4]?.status))
        obj['demo'] = this.getStepperIconAndColor(this.getPassFailGenericVal(status[5]?.status), this.getPassFailGenericVal(status[6]?.status))
        obj['interview'] = this.getStepperIconAndColor(this.getPassFailGenericVal(status[7]?.status), this.getPassFailGenericVal(status[8]?.status))
        item['stepper'] = obj;
        obj = {};
        return item;
      })
    },
    addDemoInterviewScore(data){
  return data.map((user)=>{
        if(user?.demoStatus){
          if(user.userType !== 'Teacher' && user.campaignStatus[user.campaignStatus.length-1].status == 'MAINS PASSED') {
            user.enableScheduleInterview = true
          }
          if(user.campaignStatus.filter((item)=> item.status?.includes('DEMO')).length == 0){
            user.campaignStatus.push({status: 'DEMO STARTED'})
           user.campaignStatus.push({status: 'DEMO PASSED'}) 
          }
                  
        }
        if(user?.interViewFeedback?.length > 0){
          if(user.campaignStatus.filter((item)=> item.status?.includes('INTERVIEW')).length == 0){
            user.campaignStatus.push({status: 'INTERVIEW STARTED'})
           user.campaignStatus.push({status: 'INTERVIEW PASSED'})
          }       
        }
        return user
      })
    
    },
    filterBasedOnStage(selectedStage){
     let lastStatus = '';
     lastStatus = selectedStage.slice(-1)[0]?.toLowerCase();
       this.filteredTeachers =   this.filteredTeachers.filter((item)=> item.campaignStatus.map(({status})=>status?.toLowerCase()).join("").includes(lastStatus))

  },
  filterBasedOnLeague(selectedLeague){
   this.filteredTeachers =  this.filteredTeachers.filter((teacher)=>{
      let teachersLeagueArr = teacher.coreSkillsSubject.map(({league})=> league.toLowerCase())
      console.log(teachersLeagueArr)
      return selectedLeague.some((league)=> teachersLeagueArr?.includes(league.toLowerCase()) )
        })
  },
  filterTeachers(
      selectedStage =[],
      selectedLeague =[]
    ) {
      let stageApplied = selectedStage?.length > 0
      let leagueApplied =  selectedLeague?.length > 0
      this.filteredTeachers = this.topTeacherInCluster
     
      if(stageApplied){  
       this.filterBasedOnStage(selectedStage);
      } 

      if(leagueApplied){
        this.filterBasedOnLeague(selectedLeague,);
      }
    
      this.appliedFilter=true;
      this.filterDialog=false;
    },

    calculateUsersForLeague(users) {
      users.forEach((user) => {
        var coreSkills = [];
        if (user.coreSkillsSubject !== undefined) {
          user.coreSkillsSubject.forEach((coreSkillSubject) => {
            if (coreSkillSubject.result == "PASSED") {
              coreSkills.push(coreSkillSubject);
            }
          });
        }
        user.coreSkillsSubject = coreSkills;
      });
      return users;
    },
  },
  created() {
    this.teacherSnapshotListener();
    this.setupSnapshotListenerFunnel();
    this.newTeacherFunnelChartDataListener();
    this.getLeague();
  },
};
</script>
  
<style scoped>
.tbl > .t-head > .t-row > .head {
  background-color: primary;
}

.tbl {
  height: 196px;
  width: 100%;
  text-align: left;
  border-collapse: collapse;
}

.tbl th {
  padding: 8px;
}

.tbl td {
  padding: 5px;
}

.tbl > .t-body > .t-row {
  background-color: white;
}

.head {
  text-align: center;
}

.tbl > .t-body > .t-row > .t-data {
  text-align: center;
}

.tbl > tr:nth-child(even) {
  background-color: white !important;
}
</style>